import { Form } from "./Form";
export class FormContacts extends Form {
    constructor(container, events) {
        super(container, events);
    }
    set email(value) {
        this.container.elements.namedItem('email').value = value;
    }
    set phone(value) {
        this.container.elements.namedItem('phone').value = value;
    }
}
